__turbopack_context__.v({
  "container": "EmailSignupBanner-module-scss-module__gOk44G__container",
  "privacyPolicy": "EmailSignupBanner-module-scss-module__gOk44G__privacyPolicy",
});
